import React, {useEffect, useState} from 'react';
import {Dialog, DialogContent, DialogContentText, DialogTitle, Divider, IconButton} from '@mui/material';
import {Button, Card, Form, FormControl, InputGroup, Table} from "react-bootstrap";
import CloseIcon from '@mui/icons-material/Close';
import NumberFormat from 'react-number-format';
import 'moment/locale/tr'
import {
    connectionErrorMessage,
    getUserSubscriptionAndCalculateFileCountAmountUrl,
    overFlowDosyaCountMessage,
    overFlowDosyaCountMessageId
} from "../data";
import {toast} from "react-toastify";
import {useCookies} from "react-cookie";
import PaymentModal from "../ui/modal/PaymentModal";
import OnlinePaymentDisabledNotice, {
    ONLINE_PAYMENT_ENABLED,
    disabledPaymentButtonStyle
} from "../ui/OnlinePaymentDisabledNotice";
import moment from 'moment';

const CURRENT_LIMIT_CAN_NOT_DOWNGRADE = "Mevcut Dosya Sayısı Azaltılamaz";
const PLEASE_ENTER_ADD_TO_FILE_COUNT = "Lütfen eklenecek dosya sayısı giriniz.";
const PLEASE_MAKE_CALCULATE = "Lütfen tutar hesaplama işlemi yapınız.";
const CONTACT_TO_CUSTOMER_SERVICES = "Size Özel Üyelik Modelinizi Belirlemek İçin Müşteri Temsilcimiz ile İletişime Geçiniz. 90 212 987 51 00";
const totalFileCountLimit = 50000;

function AhtapotAddFileCountFormDialog(props) {
    const selectedTenantSubscriptionViewDto = props.tenantSubscriptionViewDto;
    const [updateFileCountDto, setUpdateFileCountDto] = useState(props.ahtapotUpdateFileCountDto);
    const [cookies] = useCookies(['subscriptionToken']);
    const [updatedFileCount, setUpdatedFileCount] = useState(props.ahtapotUpdateFileCountDto?.updatedFileCount || 0);
    const [totalFileCount, setTotalFileCount] = useState(updateFileCountDto?.fileCount);
    const [visibleAmounts, setVisibleAmounts] = useState(false);
    const [addFileCountAmountDto, setAddFileCountAmountDto] = useState(null);
    const [addFileCountPaymentDto, setAddFileCountPaymentDto] = useState(null);

    useEffect(() => {
        setUpdateFileCountDto(props.ahtapotUpdateFileCountDto);
        setUpdatedFileCount(props.ahtapotUpdateFileCountDto?.updatedFileCount || 0);
        setTotalFileCount(props.ahtapotUpdateFileCountDto?.fileCount);
    }, [props.ahtapotUpdateFileCountDto]);

    const handleCalculate = async (save = false) => {
        if (updatedFileCount > totalFileCountLimit) {
            toast.info(CONTACT_TO_CUSTOMER_SERVICES, {
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }

        if (!updatedFileCount || updatedFileCount === 0) {
            toast.error(PLEASE_ENTER_ADD_TO_FILE_COUNT, {
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }

        fetch(getUserSubscriptionAndCalculateFileCountAmountUrl.concat("/").concat(props?.ownerTenantId).concat("/").concat(updatedFileCount), {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'ApiAuthorization': `Bearer ${cookies.subscriptionToken}`
            }
        }).then(res => {
            if (res.ok) {
                return res.json();
            } else {
                return res.json().then(err => {
                    console.error("err : ", err)
                    throw new Error(err.message || connectionErrorMessage);
                });
            }
        }).then((data) => {
            if (data) {
                setVisibleAmounts(true);
                setAddFileCountAmountDto(data);
                setAddFileCountPaymentDto({
                    ownerTenantId: props?.ownerTenantId,
                    totalFileCount: totalFileCount
                });
            }
        }, (error) => {
            if (error) {
                if ("WARNING_FILE_COUNT_MAX_LIMIT" === error.message) {
                    toast.info(overFlowDosyaCountMessage, {
                        position: toast.POSITION.TOP_CENTER,
                        toastId: overFlowDosyaCountMessageId
                    });
                } else {
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            } else {
                toast.error("Dosya Güncellemede Sorun Oluştu!", {
                    position: toast.POSITION.TOP_CENTER
                });
            }
        });
    };

    const handleFileCountChange = (e) => {
        if (e.target.value >= 0) {
            const value = Number(e.target.value);
            if (value > totalFileCountLimit) {
                toast.info(CONTACT_TO_CUSTOMER_SERVICES, {
                    position: toast.POSITION.TOP_CENTER
                });
            } else {
                setUpdatedFileCount(value);
                setUpdateFileCountDto(prev => ({
                    ...prev,
                    updatedFileCount: value
                }));
                setTotalFileCount(updateFileCountDto?.fileCount + value);
            }
        } else {
            toast.error(CURRENT_LIMIT_CAN_NOT_DOWNGRADE, {
                position: toast.POSITION.TOP_CENTER
            });
        }
    };

    const openPaymentModal = () => {
        if (!updatedFileCount || updatedFileCount === 0) {
            toast.error(PLEASE_ENTER_ADD_TO_FILE_COUNT, {
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }

        if (!addFileCountAmountDto || !addFileCountAmountDto?.totalAmountWithTax) {
            toast.error(PLEASE_MAKE_CALCULATE, {
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }

        props.handleCloseDialog();
        props.paymentModalOpen();
    };

    const handleCloseDialog = () => {
        setVisibleAmounts(false);
        setAddFileCountAmountDto(null);
        setTotalFileCount(props.ahtapotUpdateFileCountDto?.fileCount);
        setUpdateFileCountDto(props.ahtapotUpdateFileCountDto);
        setUpdatedFileCount(props.ahtapotUpdateFileCountDto?.updatedFileCount || 0);
        props.handleCloseDialog();
    };

    const handleResetForm = () => {
        setVisibleAmounts(false);
        setAddFileCountAmountDto(null);
        setTotalFileCount(props.ahtapotUpdateFileCountDto?.fileCount);
        setUpdateFileCountDto(props.ahtapotUpdateFileCountDto);
        setUpdatedFileCount(props.ahtapotUpdateFileCountDto?.updatedFileCount || 0);
    };

    return (
        <>
            <Dialog
                open={props.openDialog}
                onClose={props.handleCloseDialog}
                aria-labelledby="responsive-dialog-title"
                disableBackdropClick={true}
                BackdropProps={{
                    onClick: (e) => {
                        e.stopPropagation();
                    }
                }}
            >
                <DialogTitle>
                    <h1>{}</h1>
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                        <div>
                            <p style={{
                                verticalAlign: 'middle',
                                float: 'left',
                                fontSize: 30,
                                margin: 0,
                                padding: 0,
                                color: props.color
                            }}>{props.title}
                            </p>
                            {selectedTenantSubscriptionViewDto ?
                                <p>{selectedTenantSubscriptionViewDto.tenantName}</p> : null}
                        </div>
                        <IconButton
                            aria-label="close"
                            onClick={handleCloseDialog}
                            sx={{
                                position: 'absolute',
                                right: 2,
                                top: 2,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon/>
                        </IconButton>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Card>
                            <Card.Body className="font-weight-bold p-2">
                                <Table striped bordered hover responsive size="sm">
                                    <tbody>
                                    <tr>
                                        <td>
                                            <Form.Label className="pl-1">
                                                Abonelik Başlangıç Tarihi
                                            </Form.Label>
                                        </td>
                                        <td className="text-right align-middle">
                                            <FormControl
                                                type="datetime"
                                                disabled
                                                className="pl-4 text-center"
                                                value={moment(updateFileCountDto?.validIntervalBeginDateTime).locale('tr').format("LL")}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label className="pl-1">
                                                Abonelik Bitiş Tarihi
                                            </Form.Label>
                                        </td>
                                        <td className="text-center align-middle">
                                            <FormControl
                                                type="datetime"
                                                disabled
                                                className="pl-4 text-center"
                                                value={moment(updateFileCountDto.updatedDayCount > 0 ? updateFileCountDto.updatedEndDateTime :
                                                    updateFileCountDto?.validIntervalEndDateTime).locale('tr').format("LL")}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label className="pl-1">
                                                Kalan Gün Sayısı
                                            </Form.Label>
                                        </td>
                                        <td className="text-center align-middle">
                                            <FormControl
                                                type="number"
                                                disabled
                                                value={updateFileCountDto.updatedDayCount > 0 ? updateFileCountDto.updatedDayCount : updateFileCountDto?.expiryDayCount || 0}
                                                className="pl-4 text-center"
                                            />
                                        </td>
                                    </tr>
                                    <Divider/><br/><Divider/>
                                    <tr>
                                        <td>
                                            <Form.Label className="pl-1">
                                                Mevcut Dosya Sayısı
                                            </Form.Label>
                                        </td>
                                        <td className="text-center align-middle">
                                            <FormControl
                                                type="number"
                                                disabled
                                                className="pl-4 text-center"
                                                value={updateFileCountDto?.fileCount || 0}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label className="pl-1">
                                                Eklenecek Dosya Sayısı
                                            </Form.Label>
                                        </td>
                                        <td className="text-center align-middle">
                                            <FormControl
                                                type="number"
                                                className="pl-4 text-center"
                                                value={updatedFileCount}
                                                onChange={handleFileCountChange}
                                                style={{textAlign: 'right'}}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Form.Label className="pl-1">
                                                Ekleme Sonrası Toplam Dosya Sayısı
                                            </Form.Label>
                                        </td>
                                        <td className="text-center align-middle">
                                            <FormControl
                                                type="number"
                                                disabled
                                                className="pl-4 text-center"
                                                value={totalFileCount || 0}
                                            />
                                        </td>
                                    </tr>
                                    <Divider/><br/><Divider/>
                                    {visibleAmounts && (<>
                                        <tr>
                                            <td>
                                                <Form.Label className="pl-1">
                                                    Tutar
                                                </Form.Label>
                                            </td>
                                            <td>
                                                <InputGroup>
                                                    <NumberFormat
                                                        value={addFileCountAmountDto?.totalAmount || 0}
                                                        displayType={'text'}
                                                        thousandSeparator={true}
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        renderText={value =>
                                                            <Form.Control
                                                                type='text'
                                                                style={{
                                                                    "textAlign": "end",
                                                                    "verticalAlign": "middle"
                                                                }}
                                                                value={value}
                                                                disabled={true}
                                                            />
                                                        }
                                                    />
                                                    <InputGroup.Append>
                                                        <InputGroup.Text>TL</InputGroup.Text>
                                                    </InputGroup.Append>
                                                </InputGroup>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <Form.Label className="pl-1">
                                                    KDV Tutarı
                                                </Form.Label>
                                            </td>
                                            <td>
                                                <InputGroup>
                                                    <NumberFormat
                                                        value={addFileCountAmountDto?.taxAmount || 0}
                                                        displayType={'text'}
                                                        thousandSeparator={true}
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        renderText={value =>
                                                            <Form.Control
                                                                type='text'
                                                                style={{
                                                                    "textAlign": "end",
                                                                    "verticalAlign": "middle"
                                                                }}
                                                                value={value}
                                                                disabled={true}
                                                            />
                                                        }
                                                    />
                                                    <InputGroup.Append>
                                                        <InputGroup.Text>TL</InputGroup.Text>
                                                    </InputGroup.Append>
                                                </InputGroup>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <Form.Label className="pl-1">
                                                    KDV Dahil Toplam Tutar
                                                </Form.Label>
                                            </td>
                                            <td>
                                                <InputGroup>
                                                    <NumberFormat
                                                        value={addFileCountAmountDto?.totalAmountWithTax || 0}
                                                        displayType={'text'}
                                                        thousandSeparator={true}
                                                        decimalScale={2}
                                                        fixedDecimalScale={true}
                                                        renderText={value =>
                                                            <Form.Control
                                                                type='text'
                                                                style={{
                                                                    "textAlign": "end",
                                                                    "verticalAlign": "middle"
                                                                }}
                                                                value={value}
                                                                disabled={true}
                                                            />
                                                        }
                                                    />
                                                    <InputGroup.Append>
                                                        <InputGroup.Text>TL</InputGroup.Text>
                                                    </InputGroup.Append>
                                                </InputGroup>
                                            </td>
                                        </tr>
                                    </>)}
                                    </tbody>
                                </Table>
                            </Card.Body>
                            <div style={{display: 'flex', flexDirection: 'column', gap: 8, padding: '1px 5px 5px'}}>
                                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                    <Button onClick={() => handleCalculate(false)} variant="info">
                                        Tutar Hesapla
                                    </Button>
                                    <div style={{display: 'flex', gap: '8px'}}>
                                        <Button
                                            onClick={handleResetForm}
                                            variant="secondary"
                                        >
                                            Temizle
                                        </Button>
                                        <Button
                                            onClick={ONLINE_PAYMENT_ENABLED ? () => openPaymentModal() : undefined}
                                            variant={!ONLINE_PAYMENT_ENABLED ? "secondary" : "primary"}
                                            disabled={!ONLINE_PAYMENT_ENABLED}
                                            style={!ONLINE_PAYMENT_ENABLED ? disabledPaymentButtonStyle : undefined}
                                        >
                                            Ödeme Yap
                                        </Button>
                                    </div>
                                </div>
                                <OnlinePaymentDisabledNotice style={{marginTop: 0, maxWidth: '100%'}}/>
                            </div>
                        </Card>
                    </DialogContentText>
                    <>
                        <div style={{padding: 0, margin: 0, color: "#e80000", fontWeight: "bold", fontSize: "0.7rem"}}>
                            ** {CURRENT_LIMIT_CAN_NOT_DOWNGRADE}
                        </div>
                    </>
                </DialogContent>
            </Dialog>
            <PaymentModal
                payAmount={addFileCountAmountDto?.totalAmountWithTax}
                addFileCount={true}
                showModal={props?.paymentModalState}
                request={{
                    ownerTenantId: props?.ownerTenantId,
                    addFileCountPaymentDto: addFileCountPaymentDto
                }}
                close={() => {props?.paymentModalClose(); handleCloseDialog();}}
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    zIndex: 2000,
                    display: 'block',
                }}
                cookies={cookies}
            />
        </>
    );
}

export default AhtapotAddFileCountFormDialog;